// extracted by mini-css-extract-plugin
export default {"carouselWrapper":"style_carouselWrapper__8iBSY","wrapper":"style_wrapper__8JBaM","content":"style_content__zwLmh","label":"style_label__i6PER"};